export const signUrl = 'http://test.bcbpm.com/bcbpm/electronicSignature/Index.html';
// export const signUrl = 'http://10.168.2.102:8088/bcbpm/electronicSignature/Index.html';
export const systemType = '';// 判断应用系统的环境变量  党建：partyBuilding  其他.....自行扩展



// WEBPACK FOOTER //
// ./src/common/constants/const-global.js